import React from 'react';
import { Check, Shield, Download, Lock, CreditCard, Star, BookOpen, AlertTriangle } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
const MAIN_CHECKOUT_URL = 'https://pagos.docentesfelices.online/cart/50916342759730:1';
const UPSELL_CHECKOUT_URL = 'https://pagos.docentesfelices.online/cart/50916395221298:1';
const IMAGES = {
  hero: 'https://cdn.magicpatterns.com/uploads/ah8v7Yg1c64poFzQJjKuRr/mockups_etica_y_ciudadania_.png',
  bonus1: 'https://cdn.magicpatterns.com/uploads/mWxK5oNgr93oB1nF8d3zvQ/bonus_planificacion_anual_.png',
  bonus2: 'https://cdn.magicpatterns.com/uploads/67sXP5GT7nhzSt6FsNXZ3H/bonus_maletin_de_actividades_.png',
  upsell: 'https://cdn.magicpatterns.com/uploads/a3zpmYxjSoQtDTS7ZAHSbV/upsell_ciudadania_.png'
};
export function SalesPage() {
  const scrollToPricing = () => {
    window.location.href = MAIN_CHECKOUT_URL;
  };
  return <div className="font-opensans text-gray-900 bg-white min-h-screen flex flex-col w-full overflow-x-hidden" data-id="element-11">
      {/* STICKY TOP BAR */}
      <div className="sticky top-0 z-50 bg-black text-white py-1.5 px-4 text-center shadow-lg border-b-2 border-green-600" data-id="element-12">
        <div className="flex justify-center items-center gap-2 text-sm font-bold uppercase" data-id="element-13">
          <span className="text-gray-300" data-id="element-14">Oferta termina en:</span>
          <CountdownTimer data-id="element-15" />
        </div>
      </div>

      {/* HERO SECTION */}
      <section className="py-3 px-4 w-full max-w-4xl mx-auto text-center" data-id="element-16">
        <div className="bg-blue-700 text-white font-bold inline-flex items-center px-3 py-1 rounded mb-2 text-xs uppercase tracking-wide whitespace-nowrap overflow-hidden text-ellipsis max-w-full" data-id="element-17">
          PARA DOCENTES DE FORMACIÓN ÉTICA Y CIUDADANÍA EN SECUNDARIA
        </div>

        <h1 className="font-oswald text-xl md:text-2xl font-extrabold leading-tight mb-2 text-gray-900 uppercase" data-id="element-18">
          Resolvé todo tu año de{' '}
          <span className="text-green-600" data-id="element-19">Formación Ética y Ciudadanía</span>{' '}
          en un solo lugar y olvidate de planificar desde cero con{' '}
          <span className="underline decoration-green-500 decoration-2" data-id="element-20">
            FORMACIÓN ÉTICA Y CIUDADANÍA LISTA
          </span>
        </h1>

        <a href={MAIN_CHECKOUT_URL} className="block cursor-pointer hover:opacity-95 transition-opacity" data-id="element-21">
          <img src={IMAGES.hero} alt="Formación Ética y Ciudadanía Lista Pack" className="mx-auto w-full max-w-xs mb-2 drop-shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-22" />
        </a>

        <h2 className="text-sm md:text-base text-gray-700 font-semibold mb-2 max-w-2xl mx-auto" data-id="element-23">
          Sistema completo de clases, secuencias, actividades y recursos listos
          para usar de 1° a 5° año.
        </h2>

        <div className="flex flex-col md:flex-row justify-center items-center gap-1 md:gap-4 mb-3 text-sm font-bold text-gray-800" data-id="element-24">
          <div className="flex items-center gap-1" data-id="element-25">
            <Check className="text-green-600 w-4 h-4 stroke-[3]" data-id="element-26" /> Todo tu año
            resuelto
          </div>
          <div className="flex items-center gap-1" data-id="element-27">
            <Check className="text-green-600 w-4 h-4 stroke-[3]" data-id="element-28" /> Sin
            improvisar
          </div>
          <div className="flex items-center gap-1" data-id="element-29">
            <Check className="text-green-600 w-4 h-4 stroke-[3]" data-id="element-30" /> Sin empezar
            desde cero
          </div>
        </div>

        <a href={MAIN_CHECKOUT_URL} className="inline-block bg-green-600 hover:bg-green-700 text-white font-oswald text-xl md:text-2xl font-bold py-3 px-6 md:px-12 rounded-lg shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-200 uppercase w-full md:w-auto border-b-4 border-green-800" data-id="element-31">
          👉 SÍ, QUIERO ACCESO INMEDIATO
        </a>

        <div className="flex flex-wrap justify-center gap-3 md:gap-6 mt-2 text-xs text-gray-500 font-semibold uppercase" data-id="element-32">
          <span className="flex items-center gap-1" data-id="element-33">
            <Lock className="w-3 h-3" data-id="element-34" /> Pago seguro
          </span>
          <span className="flex items-center gap-1" data-id="element-35">
            <Download className="w-3 h-3" data-id="element-36" /> Descarga inmediata
          </span>
          <span className="flex items-center gap-1" data-id="element-37">
            <Shield className="w-3 h-3" data-id="element-38" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1" data-id="element-39">
            <Check className="w-3 h-3" data-id="element-40" /> Acceso de por vida
          </span>
        </div>
      </section>

      {/* PROBLEM SECTION */}
      <section className="bg-gray-100 py-8 px-4 w-full" data-id="element-41">
        <div className="max-w-4xl mx-auto" data-id="element-42">
          <p className="text-lg font-bold text-gray-800 mb-4 font-oswald uppercase border-l-4 border-red-600 pl-4" data-id="element-43">
            Si sos docente de Formación Ética y Ciudadanía, esto te va a sonar
            familiar…
          </p>

          <div className="space-y-3 text-base text-gray-700 leading-relaxed" data-id="element-44">
            <p data-id="element-45">Llegás del colegio agotado/a… y todavía tenés que planificar.</p>

            <p className="font-semibold" data-id="element-46">Horas armando clases sobre:</p>
            <ul className="grid md:grid-cols-2 gap-2 ml-4" data-id="element-47">
              {['Derechos humanos', 'Constitución y leyes', 'Democracia y ciudadanía', 'Estado y participación', 'Convivencia y resolución de conflictos', 'Igualdad, diversidad e inclusión', 'Problemáticas sociales actuales'].map(item => <li key={item} className="flex items-start gap-2" data-id="element-48">
                  <span className="text-red-500 font-bold" data-id="element-49">–</span> {item}
                </li>)}
            </ul>

            <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 space-y-2" data-id="element-50">
              <p className="flex items-center gap-2" data-id="element-51">
                <AlertTriangle className="text-yellow-500 w-4 h-4 flex-shrink-0" data-id="element-52" />{' '}
                Buscando actividades que realmente generen debate.
              </p>
              <p className="flex items-center gap-2" data-id="element-53">
                <AlertTriangle className="text-yellow-500 w-4 h-4 flex-shrink-0" data-id="element-54" />{' '}
                Preparando evaluaciones claras.
              </p>
              <p className="flex items-center gap-2" data-id="element-55">
                <AlertTriangle className="text-yellow-500 w-4 h-4 flex-shrink-0" data-id="element-56" />{' '}
                Tratando de que la materia no quede solo en teoría.
              </p>
            </div>

            <p className="text-base font-bold text-gray-900 text-center bg-white p-3 rounded border-l-4 border-green-600" data-id="element-57">
              No es falta de capacidad. Es que te falta un sistema completo que
              te sostenga todo el año.
            </p>
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="bg-black text-white py-8 px-4 text-center w-full" data-id="element-58">
        <div className="max-w-4xl mx-auto" data-id="element-59">
          <h2 className="text-green-500 font-bold tracking-widest uppercase mb-1 text-sm" data-id="element-60">
            LA SOLUCIÓN
          </h2>
          <h3 className="font-oswald text-2xl md:text-4xl font-bold mb-3 text-white uppercase" data-id="element-61">
            FORMACIÓN ÉTICA Y CIUDADANÍA LISTA
          </h3>
          <p className="text-base md:text-lg text-gray-300 mb-6 max-w-3xl mx-auto" data-id="element-62">
            Sistema integral de clases, proyectos, actividades y secuencias
            didácticas diseñadas específicamente para secundaria.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6 max-w-3xl mx-auto" data-id="element-63">
            {['Listo', 'Organizado', 'Aplicable', 'Adaptado a 1° a 5° año'].map(item => <div key={item} className="bg-gray-900 p-3 rounded border border-gray-800 flex flex-col items-center gap-1" data-id="element-64">
                  <Check className="text-green-500 w-6 h-6" data-id="element-65" />
                  <span className="font-bold text-sm" data-id="element-66">{item}</span>
                </div>)}
          </div>

          <a href={MAIN_CHECKOUT_URL} className="inline-block bg-green-600 hover:bg-green-700 text-white font-oswald text-xl font-bold py-3 px-8 rounded-lg shadow-lg hover:shadow-green-500/50 transform hover:-translate-y-1 transition-all duration-200 uppercase border-b-4 border-green-800" data-id="element-67">
            👉 QUIERO ESTE SISTEMA AHORA
          </a>
        </div>
      </section>

      {/* WHAT'S INCLUDED SECTION */}
      <section className="py-8 px-4 w-full max-w-6xl mx-auto" data-id="element-68">
        <h2 className="font-oswald text-2xl md:text-3xl font-bold text-center text-gray-900 mb-2 uppercase" data-id="element-69">
          ¿QUÉ INCLUYE FORMACIÓN ÉTICA Y CIUDADANÍA LISTA?
        </h2>
        <p className="text-center text-base text-gray-600 mb-6 max-w-3xl mx-auto" data-id="element-70">
          Material estructurado por año, con desarrollo conceptual claro,
          actividades prácticas y enfoque ciudadano real.
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-71">
          {[{
          title: '1° Año – Introducción a la Ética y la Ciudadanía',
          items: ['¿Qué es la ética?', 'Normas, valores y convivencia', 'Derechos y deberes en la escuela', 'Ciudadanía y participación', 'Identidad y pertenencia', 'Resolución pacífica de conflictos', 'Introducción a los Derechos Humanos', 'Actividades prácticas y debates guiados']
        }, {
          title: '2° Año – Derechos Humanos y Democracia',
          items: ['Declaración Universal de los Derechos Humanos', 'Estado y formas de gobierno', 'Democracia representativa y participación', 'Constitución Nacional (nociones básicas)', 'Igualdad y no discriminación', 'Diversidad cultural', 'Ciudadanía activa', 'Proyectos de reflexión y análisis de casos']
        }, {
          title: '3° Año – Estado, Leyes y Sociedad',
          items: ['División de poderes', 'Funcionamiento del Estado argentino', 'Leyes y su importancia social', 'Participación ciudadana', 'Problemáticas sociales actuales', 'Medios de comunicación y ciudadanía', 'Responsabilidad social', 'Actividades aplicadas y análisis de situaciones reales']
        }, {
          title: '4° Año – Ciudadanía, Derechos y Problemáticas Contemporáneas',
          items: ['Igualdad de género', 'Inclusión y diversidad', 'Derechos sociales', 'Justicia y equidad', 'Participación política', 'Organizaciones sociales', 'Conflictos sociales actuales', 'Proyectos de intervención escolar']
        }, {
          title: '5° Año – Ética, Ciudadanía y Mundo Actual',
          items: ['Ciudadanía global', 'Derechos humanos en el mundo actual', 'Democracia y desafíos contemporáneos', 'Estado y políticas públicas', 'Participación juvenil', 'Ética pública y responsabilidad social', 'Análisis crítico de problemáticas actuales', 'Proyecto integrador final']
        }].map((card, idx) => <div key={idx} className="bg-white rounded-xl shadow-lg border-t-4 border-blue-600 p-4" data-id="element-72">
              <h3 className="font-oswald text-base font-bold text-gray-900 mb-3 flex items-start gap-2" data-id="element-73">
                <BookOpen className="text-blue-600 w-5 h-5 flex-shrink-0 mt-0.5" data-id="element-74" />
                {card.title}
              </h3>
              <ul className="space-y-1" data-id="element-75">
                {card.items.map((item, i) => <li key={i} className="text-gray-700 text-xs flex items-start gap-2" data-id="element-76">
                    <span className="text-blue-400 mt-0.5" data-id="element-77">•</span> {item}
                  </li>)}
              </ul>
            </div>)}

          {/* Summary Card */}
          <div className="bg-green-50 rounded-xl shadow-lg border-t-4 border-green-600 p-4 flex flex-col justify-center" data-id="element-78">
            <h3 className="font-oswald text-base font-bold text-gray-900 mb-3 text-center" data-id="element-79">
              Cada cuadernillo incluye:
            </h3>
            <ul className="space-y-2" data-id="element-80">
              {['Desarrollo conceptual claro y ordenado', 'Actividades listas para usar', 'Consignas de debate', 'Propuestas de reflexión', 'Recursos didácticos', 'Material adaptable'].map((item, i) => <li key={i} className="flex items-center gap-2 font-semibold text-gray-800 text-sm" data-id="element-81">
                  <Check className="text-green-600 w-4 h-4 flex-shrink-0" data-id="element-82" />{' '}
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* RESULTS SECTION */}
      <section className="bg-black text-white py-8 px-4 w-full" data-id="element-83">
        <div className="max-w-5xl mx-auto" data-id="element-84">
          <h2 className="font-oswald text-2xl md:text-3xl font-bold text-center mb-6 uppercase" data-id="element-85">
            RESULTADOS QUE TRANSFORMAN
          </h2>

          <div className="grid md:grid-cols-2 gap-4 mb-6" data-id="element-86">
            <div className="bg-gray-900 p-5 rounded-xl border border-gray-800" data-id="element-87">
              <h3 className="text-lg font-bold text-green-500 mb-3 border-b border-gray-700 pb-2" data-id="element-88">
                Para tus estudiantes
              </h3>
              <ul className="space-y-2" data-id="element-89">
                {['Participan más', 'Debaten con fundamentos', 'Comprenden sus derechos', 'Analizan problemáticas actuales', 'Conectan la materia con la realidad'].map((item, i) => <li key={i} className="flex items-center gap-2 text-sm" data-id="element-90">
                    <span className="text-green-500" data-id="element-91">•</span> {item}
                  </li>)}
              </ul>
            </div>

            <div className="bg-gray-900 p-5 rounded-xl border border-gray-800" data-id="element-92">
              <h3 className="text-lg font-bold text-blue-500 mb-3 border-b border-gray-700 pb-2" data-id="element-93">
                Para vos como docente
              </h3>
              <ul className="space-y-2" data-id="element-94">
                {['Ahorrás horas de planificación', 'Enseñás con seguridad', 'Tenés todo organizado por año', 'Llegás sin estrés al cierre del ciclo', 'Recuperás tiempo personal'].map((item, i) => <li key={i} className="flex items-center gap-2 text-sm" data-id="element-95">
                    <span className="text-blue-500" data-id="element-96">•</span> {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="text-center" data-id="element-97">
            
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-8 px-4 bg-white w-full" data-id="element-98">
        <div className="max-w-5xl mx-auto" data-id="element-99">
          <h2 className="font-oswald text-2xl md:text-3xl font-bold text-center text-gray-900 mb-1 uppercase" data-id="element-100">
            🎁 BONOS EXCLUSIVOS INCLUIDOS HOY
          </h2>
          <p className="text-center text-red-600 font-bold text-base mb-6 uppercase" data-id="element-101">
            Estos bonos son GRATIS por el día de hoy
          </p>

          {/* Bonus 1 */}
          <div className="flex flex-col md:flex-row items-center gap-6 mb-8 border-b border-gray-200 pb-8" data-id="element-102">
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-103">
              <a href={MAIN_CHECKOUT_URL} className="block hover:scale-105 transition-transform duration-300" data-id="element-104">
                <img src={IMAGES.bonus1} alt="Planificación Anual Lista" className="w-full max-w-xs rounded-lg shadow-xl" data-id="element-105" />
              </a>
            </div>
            <div className="w-full md:w-1/2" data-id="element-106">
              <span className="bg-red-600 text-white px-2 py-0.5 rounded text-xs font-bold uppercase mb-2 inline-block" data-id="element-107">
                Valor: $15.000 (GRATIS)
              </span>
              <h3 className="font-oswald text-2xl font-bold text-gray-900 mb-1" data-id="element-108">
                🎁 BONO 1 – GRATIS
              </h3>
              <h4 className="text-xl font-bold text-green-600 mb-2" data-id="element-109">
                PLANIFICACIÓN ANUAL LISTA
              </h4>
              <p className="text-gray-700 mb-3 text-sm" data-id="element-110">
                Planificación anual completa lista para presentar.
              </p>
              <ul className="space-y-1" data-id="element-111">
                {['Objetivos', 'Contenidos', 'Fundamentación', 'Organización por unidad', 'Lista para adaptar e imprimir'].map((item, i) => <li key={i} className="flex items-center gap-2 font-semibold text-gray-800 text-sm" data-id="element-112">
                    <Check className="text-green-600 w-4 h-4" data-id="element-113" /> {item}
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="flex flex-col md:flex-row-reverse items-center gap-6" data-id="element-114">
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-115">
              <a href={MAIN_CHECKOUT_URL} className="block hover:scale-105 transition-transform duration-300" data-id="element-116">
                <img src={IMAGES.bonus2} alt="Maletín de Actividades" className="w-full max-w-xs rounded-lg shadow-xl" data-id="element-117" />
              </a>
            </div>
            <div className="w-full md:w-1/2" data-id="element-118">
              <span className="bg-red-600 text-white px-2 py-0.5 rounded text-xs font-bold uppercase mb-2 inline-block" data-id="element-119">
                Valor: $12.000 (GRATIS)
              </span>
              <h3 className="font-oswald text-2xl font-bold text-gray-900 mb-1" data-id="element-120">
                🎁 BONO 2 – GRATIS
              </h3>
              <h4 className="text-xl font-bold text-green-600 mb-2" data-id="element-121">
                MALETÍN DE ACTIVIDADES
              </h4>
              <p className="text-gray-700 mb-3 text-sm" data-id="element-122">
                Decenas de actividades prácticas listas para usar:
              </p>
              <ul className="grid grid-cols-2 gap-1" data-id="element-123">
                {['Debates estructurados', 'Estudios de caso', 'Análisis de noticias', 'Dinámicas grupales', 'Actividades reflexivas', 'Propuestas de trabajo integrador'].map((item, i) => <li key={i} className="flex items-center gap-2 font-semibold text-gray-800 text-sm" data-id="element-124">
                    <Check className="text-green-600 w-4 h-4" data-id="element-125" /> {item}
                  </li>)}
              </ul>
              <p className="mt-2 font-bold text-gray-900 italic text-sm" data-id="element-126">
                Todo preparado para aplicar directamente en el aula.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING SECTION */}
      <section id="compra" className="bg-gray-50 py-8 px-4 border-t border-gray-200 w-full" data-id="element-127">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden border-4 border-dashed border-green-600" data-id="element-128">
          <div className="bg-red-600 text-white text-center py-3 px-4" data-id="element-129">
            <h2 className="font-oswald text-xl md:text-3xl font-bold uppercase animate-pulse" data-id="element-130">
              🔥 OFERTA ESPECIAL POR TIEMPO LIMITADO
            </h2>
          </div>

          <div className="p-6 md:p-8 text-center" data-id="element-131">
            <h3 className="font-oswald text-2xl md:text-4xl font-bold text-gray-900 mb-4 uppercase" data-id="element-132">
              FORMACIÓN ÉTICA Y CIUDADANÍA LISTA
            </h3>

            <div className="flex flex-wrap justify-center gap-3 mb-5 text-xs md:text-sm font-semibold text-gray-600" data-id="element-133">
              <span className="flex items-center gap-1" data-id="element-134">
                <Check className="text-green-500 w-3 h-3" data-id="element-135" /> Acceso de por vida
              </span>
              <span className="flex items-center gap-1" data-id="element-136">
                <Check className="text-green-500 w-3 h-3" data-id="element-137" /> Descarga inmediata
              </span>
              <span className="flex items-center gap-1" data-id="element-138">
                <Check className="text-green-500 w-3 h-3" data-id="element-139" /> Garantía 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-140">
                <Check className="text-green-500 w-3 h-3" data-id="element-141" /> 2 Bonos incluidos
              </span>
            </div>

            <div className="mb-5" data-id="element-142">
              <p className="text-gray-500 text-base mb-1" data-id="element-143">
                Precio regular{' '}
                <span className="text-red-600 line-through font-bold" data-id="element-144">
                  $49.990 ARS
                </span>
              </p>
              <p className="text-green-600 font-bold text-lg mb-1" data-id="element-145">HOY</p>
              <p className="text-5xl md:text-7xl font-oswald font-bold text-gray-900 tracking-tight" data-id="element-146">
                $19.990{' '}
                <span className="text-xl text-gray-500 font-normal" data-id="element-147">ARS</span>
              </p>
            </div>

            <a href={MAIN_CHECKOUT_URL} className="block w-full bg-green-600 hover:bg-green-700 text-white font-oswald text-xl md:text-3xl font-bold py-5 px-4 rounded-xl shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-200 uppercase mb-5 border-b-8 border-green-800 leading-tight" data-id="element-148">
              👉 SÍ, QUIERO FORMACIÓN ÉTICA Y CIUDADANÍA LISTA
            </a>

            <div className="flex flex-col items-center gap-2" data-id="element-149">
              <p className="text-gray-600 font-semibold text-sm" data-id="element-150">
                Métodos de pago seguros:
              </p>
              <div className="flex flex-wrap justify-center gap-3 text-gray-500 font-bold uppercase text-xs" data-id="element-151">
                <span className="flex items-center gap-1" data-id="element-152">
                  <CreditCard className="w-3 h-3" data-id="element-153" /> MERCADO PAGO
                </span>
                <span data-id="element-154">|</span>
                <span data-id="element-155">VISA</span>
                <span data-id="element-156">|</span>
                <span data-id="element-157">MASTERCARD</span>
                <span data-id="element-158">|</span>
                <span data-id="element-159">TRANSFERENCIA por whatsapp</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HOW TO RECEIVE */}
      <section className="py-8 px-4 bg-white w-full" data-id="element-160">
        <div className="max-w-4xl mx-auto" data-id="element-161">
          <h2 className="font-oswald text-2xl font-bold text-center text-gray-900 mb-6 uppercase" data-id="element-162">
            ¿CÓMO RECIBÍS EL MATERIAL?
          </h2>

          <div className="grid md:grid-cols-3 gap-5" data-id="element-163">
            {[{
            step: 1,
            text: 'Realizás la compra e ingresás tu correo.'
          }, {
            step: 2,
            text: 'Finalizás el pago de forma segura.'
          }, {
            step: 3,
            text: 'Recibís automáticamente el link de descarga.',
            sub: '⚠️ Revisá spam si no lo ves.'
          }].map(item => <div key={item.step} className="flex flex-col items-center text-center" data-id="element-164">
                <div className="w-12 h-12 bg-black text-white rounded-full flex items-center justify-center text-xl font-bold mb-3 shadow-lg" data-id="element-165">
                  {item.step}
                </div>
                <p className="font-bold text-base text-gray-800" data-id="element-166">
                  Paso {item.step}
                </p>
                <p className="text-gray-600 text-sm" data-id="element-167">{item.text}</p>
                {item.sub && <p className="text-red-500 text-xs font-bold mt-1" data-id="element-168">
                    {item.sub}
                  </p>}
              </div>)}
          </div>
        </div>
      </section>

      {/* UPSELL SECTION */}
      <section className="bg-black text-white py-8 px-4 border-t-4 border-yellow-400 w-full" data-id="element-169">
        <div className="max-w-5xl mx-auto" data-id="element-170">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-171">
            <Star className="text-yellow-400 fill-yellow-400 w-6 h-6" data-id="element-172" />
            <h2 className="text-yellow-400 font-bold text-xl uppercase tracking-widest" data-id="element-173">
              MÁS POPULAR
            </h2>
            <Star className="text-yellow-400 fill-yellow-400 w-6 h-6" data-id="element-174" />
          </div>

          <div className="bg-gray-900 rounded-2xl p-6 md:p-8 border border-gray-700 shadow-2xl" data-id="element-175">
            <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-176">
              <div className="w-full md:w-1/2" data-id="element-177">
                <a href={UPSELL_CHECKOUT_URL} className="block hover:opacity-90 transition-opacity" data-id="element-178">
                  <img src={IMAGES.upsell} alt="Sistema Pro de Evaluaciones" className="w-full rounded-lg shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-179" />
                </a>
              </div>

              <div className="w-full md:w-1/2" data-id="element-180">
                <h3 className="font-oswald text-2xl md:text-3xl font-bold text-white mb-4 uppercase leading-tight" data-id="element-181">
                  FORMACIÓN ÉTICA Y CIUDADANÍA LISTA +{' '}
                  <span className="text-yellow-400" data-id="element-182">
                    SISTEMA PRO DE EVALUACIONES
                  </span>
                </h3>

                <div className="bg-gray-800 p-4 rounded-lg mb-4 border-l-4 border-yellow-400" data-id="element-183">
                  <h4 className="font-bold text-sm mb-3 text-yellow-400" data-id="element-184">
                    🎯 ¿Qué incluye el SISTEMA PRO DE EVALUACIONES?
                  </h4>
                  <ul className="grid grid-cols-1 gap-1 text-sm" data-id="element-185">
                    {['Banco profesional de evaluaciones listas', 'Instrumentos de evaluación por año', 'Rúbricas detalladas', 'Evaluaciones escritas', 'Evaluaciones con análisis de casos', 'Modelos de trabajos prácticos', 'Criterios de corrección claros', 'Sistema organizado para todo el ciclo'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-186">
                        <Check className="text-green-500 w-4 h-4 flex-shrink-0 mt-0.5" data-id="element-187" />{' '}
                        {item}
                      </li>)}
                  </ul>
                  <p className="mt-3 font-bold text-white italic text-sm" data-id="element-188">
                    Ideal para dejar de improvisar exámenes.
                  </p>
                </div>

                <div className="mb-4" data-id="element-189">
                  <p className="text-gray-400 text-sm" data-id="element-190">
                    Precio regular{' '}
                    <span className="text-red-500 line-through" data-id="element-191">
                      $34.990 ARS
                    </span>
                  </p>
                  <div className="flex items-baseline gap-2" data-id="element-192">
                    <p className="text-green-500 font-bold text-base" data-id="element-193">HOY</p>
                    <p className="text-4xl font-oswald font-bold text-white" data-id="element-194">
                      $24.990{' '}
                      <span className="text-base text-gray-400 font-normal" data-id="element-195">
                        ARS
                      </span>
                    </p>
                  </div>
                  <p className="text-yellow-400 font-bold mt-1 bg-yellow-400/10 inline-block px-2 py-0.5 rounded text-sm" data-id="element-196">
                    Ahorrás $10.000 ARS
                  </p>
                </div>

                <a href={UPSELL_CHECKOUT_URL} className="block w-full bg-green-600 hover:bg-green-700 text-white font-oswald text-lg md:text-xl font-bold py-3 px-4 rounded-lg shadow-lg hover:shadow-green-500/50 transform hover:-translate-y-1 transition-all duration-200 uppercase text-center border-b-4 border-green-800" data-id="element-197">
                  👉 SÍ, QUIERO EL SUPER PACK COMPLETO
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE SECTION */}
      <section className="py-8 px-4 bg-gray-100 w-full" data-id="element-198">
        <div className="max-w-3xl mx-auto text-center" data-id="element-199">
          <Shield className="w-14 h-14 text-green-600 mx-auto mb-3" data-id="element-200" />
          <h2 className="font-oswald text-2xl font-bold text-gray-900 mb-2 uppercase" data-id="element-201">
            GARANTÍA DE SATISFACCIÓN TOTAL
          </h2>
          <p className="text-base text-gray-700 leading-relaxed" data-id="element-202">
            Probalo 7 días. Si no cumple tus expectativas, te devolvemos el
            100%. <span className="font-bold" data-id="element-203">Sin preguntas.</span>
          </p>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-8 px-4 bg-white w-full" data-id="element-204">
        <div className="max-w-6xl mx-auto" data-id="element-205">
          <h2 className="font-oswald text-2xl font-bold text-center text-gray-900 mb-6 uppercase" data-id="element-206">
            TESTIMONIOS DE DOCENTES EN ARGENTINA
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-207">
            {[{
            quote: 'Ahora tengo todo el año organizado. No improviso más.',
            author: 'Mariana G.',
            loc: 'Córdoba'
          }, {
            quote: 'Las clases generan debate real.',
            author: 'Luciano R.',
            loc: 'Buenos Aires'
          }, {
            quote: 'El material está claro y bien estructurado.',
            author: 'Carolina P.',
            loc: 'Mendoza'
          }, {
            quote: 'Me ahorró horas de planificación.',
            author: 'Paula M.',
            loc: 'Rosario'
          }].map((t, i) => <div key={i} className="bg-gray-50 p-4 rounded-xl shadow border border-gray-100 flex flex-col" data-id="element-208">
                <div className="flex text-yellow-400 mb-2" data-id="element-209">
                  {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-3 h-3 fill-current" data-id="element-210" />)}
                </div>
                <p className="text-gray-700 italic mb-3 flex-grow text-sm" data-id="element-211">
                  "{t.quote}"
                </p>
                <div data-id="element-212">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-213">{t.author}</p>
                  <p className="text-xs text-gray-500" data-id="element-214">{t.loc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="bg-black text-white py-10 px-4 text-center w-full" data-id="element-215">
        <div className="max-w-4xl mx-auto" data-id="element-216">
          <h2 className="font-oswald text-3xl md:text-4xl font-bold mb-4 uppercase" data-id="element-217">
            ¿LISTO/A PARA TRANSFORMAR TU AÑO?
          </h2>
          <p className="text-lg text-gray-300 mb-6" data-id="element-218">
            Sumate a docentes que ya dejaron de improvisar.
          </p>

          <a href={MAIN_CHECKOUT_URL} className="inline-block bg-green-600 hover:bg-green-700 text-white font-oswald text-2xl md:text-3xl font-bold py-5 px-10 rounded-xl shadow-2xl hover:shadow-green-500/50 transform hover:-translate-y-1 transition-all duration-200 uppercase border-b-8 border-green-800" data-id="element-219">
            👉 QUIERO EMPEZAR AHORA
          </a>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-900 text-gray-500 py-6 px-4 text-center text-xs w-full" data-id="element-220">
        <div className="max-w-4xl mx-auto" data-id="element-221">
          <div className="flex items-center justify-center gap-2 mb-2 font-bold text-gray-400 uppercase tracking-widest text-xs" data-id="element-222">
            <BookOpen className="w-4 h-4" data-id="element-223" />
            FORMACION ETICA Y CIUDADANIA
          </div>
          <p className="mb-2" data-id="element-224">© 2026 FORMACION ETICA Y CIUDADANIA ™</p>
          <div className="flex justify-center gap-4" data-id="element-225">
            <span className="cursor-pointer hover:text-white" data-id="element-226">Términos</span>
            <span className="cursor-pointer hover:text-white" data-id="element-227">Privacidad</span>
            <span className="cursor-pointer hover:text-white" data-id="element-228">Soporte</span>
          </div>
        </div>
      </footer>
    </div>;
}